/**
 * @generated SignedSource<<8d1557370f31dfe033e03c74aa80d5d7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MetaAdCallToAction = "CONTACT_US" | "GET_QUOTE" | "LEARN_MORE" | "SHOP_NOW" | "SIGN_UP" | "SUBSCRIBE" | "%future added value";
export type VisualAssetType = "IMAGE" | "VIDEO" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type MetaAdPreview$data = {
  readonly callToAction: MetaAdCallToAction | null;
  readonly description: string | null;
  readonly destinationUrl: string | null;
  readonly displayUrl: string | null;
  readonly facebookPage: {
    readonly name: string;
    readonly picture: string;
  } | null;
  readonly facebookPageId: string | null;
  readonly headline: string | null;
  readonly id: string;
  readonly instagramAccount: {
    readonly name: string;
    readonly picture: string;
  } | null;
  readonly instagramAccountId: string | null;
  readonly metaAdMetaAdSets: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly primaryText: string | null;
  readonly visualAssets: ReadonlyArray<{
    readonly type: VisualAssetType;
    readonly url: string;
  }>;
  readonly " $fragmentType": "MetaAdPreview";
};
export type MetaAdPreview$key = {
  readonly " $data"?: MetaAdPreview$data;
  readonly " $fragmentSpreads": FragmentRefs<"MetaAdPreview">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "picture",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MetaAdPreview",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "callToAction",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "destinationUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "primaryText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "facebookPageId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "instagramAccountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FacebookPage",
      "kind": "LinkedField",
      "name": "facebookPage",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InstagramAccount",
      "kind": "LinkedField",
      "name": "instagramAccount",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MetaAdMetaAdSet",
      "kind": "LinkedField",
      "name": "metaAdMetaAdSets",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "VisualAsset",
      "kind": "LinkedField",
      "name": "visualAssets",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MetaAd",
  "abstractKey": null
};
})();

(node as any).hash = "96cf75d776556f3f0ada406aa662ace1";

export default node;
